export default __webpack_public_path__ + "static/media/verticalBusPlan.61513ada.svg";